import { CanDeactivateFn } from '@angular/router';
import { NotesScreenComponent } from '@libs/notes';
import { Observable, of } from 'rxjs';

export const notesInprogressSavingGuard: CanDeactivateFn<NotesScreenComponent> = (component: NotesScreenComponent): Observable<boolean> => {
  // First check if note is currently saving - block immediately
  if (component.isNoteSavingInProgress()) {
    return of(false);
  }

  // Check if in addendum mode with unsaved content
  if (component.canDeactivate) {
    return component.canDeactivate();
  }

  return of(true);
};
